query PromocodesList(
  $page: Int
  $rowsPerPage: Int
  $filter: PromocodesFilterInput
) {
  promocodes(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      code
      productIds
      limit
      amount
      discount
      activations
      trialPeriod
      type
      startAt
      finishAt
      totalRevenue {
        value
        currency
      }
      promocodeCampaign {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
}
